module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-wrapper"><div class="dialog modal-dialog dialog-edu-global"><div class="dialog-mask"></div><div class="dialog-main"><button class="vertical-a iconfont icon-close close-edu-global">x</button><div class="dialog-body"><div class="add-form-dialog-body"><div class="title">教育专业版认证申请</div><div class="body"><p>请准备好如下材料信息，通过邮箱 support@umu.com 联系UMU免费升级为教育专业版。</p><p>1. 已注册的UMU账户信息（用户名、邮箱或手机号信息）。</p><p>2. 在职教师工作证或其他可以证明您身份的在职证明。</p></div><div class="footer"><button class="btn-confirm close-edu-global">知道了</button></div></div></div></div></div></div>\n';

}
return __p
}